import { ClientServiceType } from '../../domain/services/client-service';
import fetch from 'isomorphic-unfetch';
import Client from '../../domain/models/client';

export class ClientService implements ClientServiceType {
  async listClients(filter: any, txt: string): Promise<Client[]> {
    const url = `${process.env.NEXT_PUBLIC_API_URL}/clients/list`;
    // const url = `https://api.virtualvox.net/clients/list`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(txt && txt.length > 0 ? { ...filter, ...{ search: txt } } : filter)
    });
    const resData = await res.json();
    if (res.ok) {
      const clients = resData.map((o) => new Client().fromJson(o));
      return clients;
    }
    return [];
  }

  async getClientBySlug(slug: string): Promise<Client> {
    const url = `${process.env.NEXT_PUBLIC_API_URL}/clients/slug/${slug}`;
    // const url = `https://api.virtualvox.net/clients/slug/${slug}`;
    const res = await fetch(url);
    const resData = await res.json();
    if (res.ok) {
      const client = new Client().fromJson(resData);
      return client;
    }
    throw new Error(resData.message);
  }
}
